/* SelectBoxEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class SelectBoxEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
    }

    _init() {
        const dropDownData = _.get(this._itemData, "ciAttributesDropDownData", []);
        if (!dropDownData.some((i) => i.value === "other")) {
            dropDownData.push({label: "Other", value: "other"});
        }
        this.input.setOptions(dropDownData);
        super._init();

        if (this._itemData["cmdbAttr"].indexOf("other_field.") > -1) {
            this.rootElement.classList.add("other-present");
            const textBox = document.createElement("input");
            textBox.setAttribute("type", "text");
            textBox.classList.add("other-textbox");
            this.rootElement.appendChild(textBox);

            textBox.value = this._itemData["nbExtendedPropPath"];
        }
    }

    _onUserValue(val) {
        if (val.indexOf("other") > -1) {
            if (!this.rootElement.querySelector(".other-textbox")) {
                const textBox = document.createElement("input");
                textBox.setAttribute("type", "text");
                textBox.classList.add("other-textbox");
                this.rootElement.appendChild(textBox);
            }
            this.rootElement.classList.add("other-present");
        } else {
            const otherTextBox = this.rootElement.querySelector(".other-textbox");
            if (otherTextBox) {
                otherTextBox.remove();
            }
            this.rootElement.classList.remove("other-present");
        }
    }

    applyValue(item, state) {
        item[this._fieldName] = state;
        if (item.type === "xDome" || item.type === "xDome_site") {
            if (state.indexOf("other") > -1) {
                const currentValue = _.trim(this.rootElement.querySelector(".other-textbox").value);
                item["xdExtendedPropPath"] = currentValue;
                item[this._fieldName] = "other_field." + "_" + currentValue;
                delete item["xdPropType"];
                delete item["xdPropPath"];
            } else {
                const currentPathObj = item.ciAttributesDropDownData.find((i) => i.value === state);
                item["xdPropPath"] = _.get(currentPathObj, "path", []);
                const options = this.input.getOptions();
                const _type = this.findType(options, state);
                item["xdPropType"] = _type;
                delete item["xdExtendedPropPath"];
            }
        } else if (item.type === "netBox" || item.type === "netBox_site") {
            if (state.indexOf("other") > -1) {
                const currentValue = _.trim(this.rootElement.querySelector(".other-textbox").value);
                item["nbExtendedPropPath"] = currentValue;
                item[this._fieldName] = "other_field." + "_" + currentValue;
                delete item["nbPropType"];
                delete item["nbPropPath"];
            } else {
                const currentPathObj = item.ciAttributesDropDownData.find((i) => i.value === state);
                item["nbPropPath"] = _.get(currentPathObj, "path", []);
                const options = this.input.getOptions();
                const _type = this.findType(options, state);
                item["nbPropType"] = _type;
                delete item["nbExtendedPropPath"];
            }
        } else {
            const options = this.input.getOptions();
            const _type = this.findType(options, state);
            item["cmdbAttrType"] = _type;
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: true,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }

    loadValue(item) {
        const fieldValue = item[this._fieldName];
        this.initialData = fieldValue;
        if (fieldValue.indexOf("other") > -1) {
            this.input.setValue("other");
        } else {
            this.input.setValue(fieldValue);
        }
    }

    findType(entries, valueToFind) {
        // Iterate through each entry in the input
        for (const entry of entries) {
            // Check if the current entry's value matches the value to find
            if (entry.value === valueToFind) {
                // Return the type if a match is found
                return entry.type;
            }
        }
        // Return null if the value is not found in any entry
        return null;
    }
    hide() {}
    show() {}
}

module.exports = SelectBoxEditor;
